function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { Alert, message as antdMessage } from "antd";
import React from "react";
import { CloseCircleOutlined, InfoCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import { isString } from "lodash";
var CloseIcon = function CloseIcon() {
  return /*#__PURE__*/React.createElement("img", {
    src: "".concat(settings.S3CDN).concat(settings.viewAssetsPath, "close-white.png"),
    className: "close-icon"
  });
};
var CheckMarkIcon = function CheckMarkIcon() {
  return /*#__PURE__*/React.createElement("img", {
    src: "".concat(settings.S3CDN).concat(settings.viewAssetsPath, "checkMark.png"),
    className: "sucess-icon"
  });
};
var msgIconEl = {
  success: CheckMarkIcon,
  error: CloseCircleOutlined,
  info: InfoCircleOutlined,
  warning: ExclamationCircleOutlined
};
var MessageContent = function MessageContent(props) {
  var icon = props.icon,
    _props$type = props.type,
    type = _props$type === void 0 ? "error" : _props$type,
    closeIcon = props.closeIcon;
  var DefaultIcon = msgIconEl[type];
  return /*#__PURE__*/React.createElement(Alert, _extends({
    type: type,
    icon: icon || /*#__PURE__*/React.createElement(DefaultIcon, null),
    closeIcon: closeIcon || /*#__PURE__*/React.createElement(CloseIcon, null),
    showIcon: true,
    closable: true
  }, props));
};
var defaultMessageProps = {
  content: "",
  type: "error",
  duration: 5
};
export function message(props) {
  if (!props) {
    return;
  }
  var _props = isString(props) ? _objectSpread(_objectSpread({}, defaultMessageProps), {}, {
    content: props
  }) : _objectSpread(_objectSpread({}, defaultMessageProps), props);
  var type = _props.type,
    content = _props.content;
  return antdMessage.open(_objectSpread(_objectSpread({
    type: type,
    icon: /*#__PURE__*/React.createElement(React.Fragment, null),
    className: "custom-editor-msg"
  }, _props), {}, {
    content: /*#__PURE__*/React.createElement(MessageContent, {
      message: content,
      type: type,
      onClose: function onClose() {
        return antdMessage.destroy();
      }
    })
  }));
}